import React from "react";
import brand from "../brand";

const AboutUs = () => {
  return (
    <main className="page-shell legal-page">
      <section className="page-hero compact-hero">
        <span className="eyebrow">About</span>
        <h1>About {brand.name}</h1>
        <p>
          {brand.name} is built as a clean result information platform for daily
          lottery updates, archive browsing, PDF downloads, and fast mobile access.
        </p>
      </section>
      <section className="legal-copy">
        <p>
          We focus on presenting result information in a reliable and accessible
          format. We do not conduct lottery draws or sell lottery tickets through
          this website. Our goal is to make published result material easier to
          read, search, and share.
        </p>
      </section>
    </main>
  );
};

export default AboutUs;
